import { render, staticRenderFns } from "./sendallTeacher.vue?vue&type=template&id=35181532&"
import script from "./sendallTeacher.vue?vue&type=script&lang=js&"
export * from "./sendallTeacher.vue?vue&type=script&lang=js&"
import style0 from "./sendallTeacher.vue?vue&type=style&index=0&id=35181532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports